import { formatDate, formatTime } from '@ubus/shared';

/** Fields used to build an operator-facing trip label (no UUID). */
export type TripBriefInput = {
  date?: string | null;
  pickup_time?: string | null;
  pickup_address?: string | null;
  organizations?: { name?: string | null } | null;
};

/**
 * Human label for ops UI: org · date · time (falls back to pickup address).
 * Never returns a UUID fragment as the primary label.
 */
export function formatTripBrief(trip: TripBriefInput | null | undefined, fallback = 'Trip'): string {
  if (!trip) return fallback;
  const org = trip.organizations?.name?.trim();
  const date = trip.date ? formatDate(trip.date) : '';
  const time = trip.pickup_time ? formatTime(String(trip.pickup_time)) : '';
  const parts = [org, date, time].filter(Boolean);
  if (parts.length > 0) return parts.join(' · ');
  const addr = trip.pickup_address?.trim();
  if (addr) return addr.length > 48 ? `${addr.slice(0, 48)}…` : addr;
  return fallback;
}

export function formatTripErrorPrefix(trip: TripBriefInput | null | undefined): string {
  return formatTripBrief(trip, 'Trip');
}
